const isStorageAvailable = (storageType: 'localStorage' | 'sessionStorage') => {
    try {
        return storageType in window && window[storageType] !== null;
    } catch (e) {
        return false;
    }
};

export default isStorageAvailable;
